// export const base = 'display';

export const variant = {
  xl: 'text-display-xl sm:text-display-xl-sm md:text-display-xl-md xl:text-display-xl-xl',
  l: 'text-display-l sm:text-display-l-sm md:text-display-l-md xl:text-display-l-xl',
  m: 'text-display-m sm:text-display-m-sm md:text-display-m-md xl:text-display-m-xl',
  s: 'text-display-s sm:text-display-s-sm md:text-display-s-md xl:text-display-s-xl',
};
